import gitInfo from '../git-info.json';
import { resetDomainStores } from './domains/stores';
import { isAppOutdated, updateStoredCommitId } from './storage/git-info-storage';
import { getStorageKey } from './storage/utils/storage-key';
import { logger } from './utils/logger';
const key = getStorageKey('commit-id');
/**
 * Clears all occ domain data from storage if outdated and stores the latest commit ID.
 */
export const handleAppUpdate = () => {
    const { commit } = gitInfo;
    if (!isAppOutdated(key, commit))
        return;
    logger.info('The app has new changes. Clearing OCC domain stores to reflect updates.');
    resetDomainStores();
    updateStoredCommitId(key, gitInfo.commit);
};
//# sourceMappingURL=handle-app-update.js.map